import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, removeByRole, milesNumber, getRemotedbUrl, isNotEmpty, formatCurrencyPrice } from '../../lib/ep.js';
import { useOwner } from '../context/context.js';
import { stage_promotion_types as stage_promotion_types } from '../../data/bootstrap_stages';

import ActionLink from '../builder/ActionLink';
import Spinner from '../builder/Spinner';
import ProgressBar from '../builder/ProgressBar';
import { ProfileModule } from '../ui_items/Module.js';

const StatusPromotion = (props) => {
	const owner = useOwner();

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promotion = owner?.promotion?.Promotion ?? false;
	if(promotion === false) return null;

	const limit_participants = promotion?.limit_participants ?? 0;
	if(limit_participants == 0) return null;

	let current_users = (promotion.current_users != undefined) ? promotion.current_users : 0;
	if(promotion.multi_participation) current_users = (promotion.current_uniqusers != undefined) ? promotion.current_uniqusers : current_users;

	const progress = (current_users > 0) ? Math.min(100, Math.floor(100 * current_users / limit_participants)) : 0;

	let color;
	if(progress >= 80) {
		color = 'redBg whiteColor';
	} else if(progress >= 50) {
		color = 'orangeBg whiteColor';
	} else {
		color = 'greenBg whiteColor';
	}

	let label = false;
	let link;
	let target = '_self';

	const upgrade_price = props?.upgrade_price ?? {};

	switch(promotion.promo_type) {
		case '0':
		case '1':
			// link = `/promotions/upgrade/${promotion.id}`;
			// if(parseInt(props.next_limit) > limit_participants){
			// 	label = props.intl.formatMessage({ id:"Extend to {next_limit} users for {price}"}, { next_limit:milesNumber(props.next_limit), price:formatCurrencyPrice(upgrade_price[window.currency]) });
			// }
			// target = null;
			// break;
		case '2':
			link = `${window.web_base_url}${((window.is_spanish) ? 'contacto/' : 'contact/')}`;
			label = i18n("Contact sales to extend the limit");
			target = '_blank';
			break;
	}


	return (
		<div class="user_status">
			<ProgressBar
				actual={current_users}
				max={limit_participants}
				color={color}
				progress_label={(progress >= 100) ? i18n("WARNING: Limit reached!") : null}
				size="big"
				display_percent={false}
			/>

			<div class="action_links">
				<div>
					<ActionLink
						_href={`${window.zendesk_base_url}4407761507988`}
						_target="_blank"
					>What happen if I reach the limit?</ActionLink>

					{(label) && (
						<ActionLink
							_href={link}
							_target={target}
							autotranslate={false}
						>{label}</ActionLink>
					)}
				</div>

				<p>{`${i18n("Limit")}: ${milesNumber(limit_participants)}`}</p>
			</div>
		</div>
	)
};

const SingleItem = (props) => {
	const icon = props?.icon ?? '';
	const label = props?.label ?? "Data";
	const total = props?.total ?? false;
	const loading = props?.loading ?? false;

	let classes = ['gui_pos_rel'];
	if(isNotEmpty(props, 'extra_class')) classes.push(props.extra_class);

	return (
		<li>
			<div>
				<p class={`${icon} gui_padded_icon gui_small_icon`}>{label}:</p>

				<div class={classes.join(" ")}>
					{(total !== false) && (
						<strong class="total_value">{total}</strong>
					)}

					{(loading) && (
						<Spinner _class={{ h_position:'right' }} />
					)}
					
					{(!loading && props.action != undefined) && (
						<span>
							[{props.action}]
						</span>
					)}
				</div>
			</div>

			{(props.children != undefined) && (
				props.children
			)}
		</li>
	)
};

const MainStats = (props) => {
	const owner = useOwner();

	const [ calculate_time_game, setCalculateTimeGame ] = useState(false);
	const [ checking_analytics, setCheckingAnalytics ] = useState(false);
	const [ total_time, setTotalTime ] = useState(props?.total_time ?? "");
	const [ total_visits, setTotalVisits ] = useState(props?.total_visits ?? -1);
	const [ total_pageviews, setTotalPageviews ] = useState(props?.total_pageviews ?? -1);

	const promotion = owner?.promotion?.Promotion ?? false;
	if(promotion === false) return null;

	useEffect(() => {
		const promo_label = props?.promo_labels?.current[0] ?? {};
		if(Object.keys(promo_label).length > 0) removeByRole(promo_label, props.roles);
	}, []);

	const updatePlayedTime = () => {
		setCalculateTimeGame(true);

		$.post(getRemotedbUrl(`/utils/calculate_time_game/${promotion.id}`), (r) => {
			if(r.status) setTotalTime(r.time);
			setCalculateTimeGame(false);
		}, 'JSON');
	};

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const total_games = props?.total_games ?? 0;
	const total_roulettes = props?.total_roulettes ?? 0;
	const total_ocr = props?.total_ocr ?? 0;

	const enableStats = (promotion.promo_type > 0 || (promotion?.config?.addons?.stats ?? false)) ? true : false;
	const label_view_stats = (enableStats) ? "View" : "More information";

	const enableMails = (promotion.promo_type > 0 || (promotion?.config?.addons?.email ?? false)) ? true : false;
	const label_view_mails = (enableMails) ? "View" : "More information";

	const is_multiparticipation = promotion?.multi_participation ?? false;
	let has_my_networks = promotion.my_networks?.sections ?? false;

	const limit_ocr = promotion?.total_ocr_month ?? 5000;

	return (
		<ProfileModule _class={{other:'not_designer'}} title={{ label:"Main statistics", icon:'knk-stats' }}>
			<ul class="gui_clean_listed_elements">
				{(is_multiparticipation) && (
					<SingleItem
						icon='knk-users'
						total={promotion.current_uniqusers}
						label={i18n("Users")}
						action={<ActionLink
							_href={getRemotedbUrl(`/users/audience/${promotion.id}`)}
						>View</ActionLink>}
					><StatusPromotion {...props} /></SingleItem>
				)}

				<SingleItem
					icon={(is_multiparticipation) ? 'knk-entries' : 'knk-users'}
					total={promotion.current_users}
					label={i18n(is_multiparticipation) ? "Participations" : "Users"}
					action={<ActionLink
						_href={getRemotedbUrl(`/users/${(is_multiparticipation) ? 'activity' : 'registered'}/${promotion.id}`)}
					>View</ActionLink>}
				>
					{(!is_multiparticipation) && (
						<StatusPromotion {...props} />
					)}
				</SingleItem>

				{(has_my_networks) && (
					<SingleItem
						icon='knk-networks'
						total={promotion.gained_followers}
						label={i18n("Visits to My Networks")}
						action={<ActionLink
							_href={getRemotedbUrl(`/insights/${promotion.id}#networks`)}
						>View</ActionLink>}
					/>
				)}

				{(promotion.prize_downloads) && (
					<SingleItem
						icon='knk-download'
						total={promotion.prize_downloads}
						label={i18n("Prize downloads")}
						action={<ActionLink
							_href={getRemotedbUrl(`/insights/${promotion.id}#prizes`)}
						>View</ActionLink>}
					/>
				)}

				<SingleItem
					icon='knk-share'
					total={enableStats ? promotion.total_shares : null}
					label={i18n("Share button clicks")}
					action={<ActionLink
						_href={getRemotedbUrl(`/insights/${promotion.id}#shares`)}
					>{label_view_stats}{}</ActionLink>}
				/>
				
				{(promotion.total_votes > 0 && (promotion.votable_entries == '1' /* || promotion.promotion_type_id == stage_promotion_types.MEDIA_CONTEST.id*/)) && (
					<SingleItem
						icon='knk-like'
						total={promotion.total_votes}
						label={i18n("Total votes")}
						action={<ActionLink
							//_href={(promotion.promotion_type_id == stage_promotion_types.MEDIA_CONTEST.id) ? getRemotedbUrl(`/users/audience/${promotion.id}/votes/`) : getRemotedbUrl(`/insights/${promotion.id}#votes`)}
							_href={getRemotedbUrl(`/insights/${promotion.id}#votes`)}
						>{label_view_stats}</ActionLink>}
					/>
				)}

				<SingleItem
					icon='knk-visible'
					total={enableStats ? total_pageviews : null}
					label={i18n("Total page views")}
					loading={checking_analytics}
					action={<ActionLink
						_href={getRemotedbUrl(`/insights/${promotion.id}#pageviews`)}
					>{label_view_stats}</ActionLink>}
				/>

				<SingleItem
					icon='knk-send'
					total={enableMails ? promotion.total_sent_mails : null}
					label={i18n("Total emails sent")}
					action={<ActionLink
						_href={getRemotedbUrl(`/emails/index/${promotion.id}`)}
					>{label_view_mails}</ActionLink>}
				/>

				{(promotion.is_game && total_games>0) && (
					<SingleItem
						icon='knk-videogame'
						total={total_games}
						label={i18n("Total Games played")}
						action={<ActionLink
							_href={getRemotedbUrl(`/insights/${promotion.id}#game`)}
						>{label_view_stats}</ActionLink>}
					/>
				)}
				{(promotion.is_game && total_games>0) && (
					<SingleItem
						icon='knk-time'
						total={(total_time != '') ? total_time : null}
						label={i18n("Total Time played")}
						loading={calculate_time_game}
						action={(total_time != '') ? (
							<ActionLink
								_href={getRemotedbUrl(`/insights/${promotion.id}#game`)}
							>{label_view_stats}</ActionLink>
						) : (
							<ActionLink
								onClick={() => updatePlayedTime()}
							>Calculate</ActionLink>
						)}
					/>
				)}
				{(total_ocr > 0) && (
					<SingleItem
						icon='knk-buy-ticket'
						total={`${total_ocr} / ${limit_ocr}`}
						label={i18n("OCR Legacy receipt validations")}
						extra_class={(total_ocr > limit_ocr) ? 'redColor' : null}
						action={(total_ocr > limit_ocr) ? (
							<ActionLink
								_href={`${window.web_base_url}${(window.is_spanish) ? 'contacto/' : 'contact/'}`}
								_class={{ color:'redColor' }}
							>Contact sales</ActionLink>
						) : null}
					/>
				)}
			</ul>
		</ProfileModule>
	);
}

export default injectIntl(MainStats);